// https://music.youtube.com/watch?v=TXQBHblSCIc&si=ZbLOUnI_NtDUmBFs&t=55
// https://www.youtube.com/embed/lZFHMBE9UiY?si=OBDrosMZoGOr6sr2
// https://www.youtube.com/watch?v=lZFHMBE9UiY&ab_channel=MaxQNEI
// https://youtu.be/lZFHMBE9UiY?si=walBoey4DEpiEDzr&t=2090
// https://youtu.be/shorts/lZFHMBE9UiY?si=walBoey4DEpiEDzr&t=2090
const REYoutubeIdEmbed = /^((https?\:\/\/)?((www|music)\.)?youtube\.com\/embed\/([a-zA-Z0-9\-\_]{11})(\?.*?)?)$/;
const REYoutubeIdUrl = /^((https?\:\/\/)?((www|music)\.)?youtube\.com\/watch\?v\=([a-zA-Z0-9\-\_]{11})(\&.*?)?)$/;
const REYoutubeIdShare = /^((https?\:\/\/)?youtu\.be\/(shorts\/)?([a-zA-Z0-9\-\_]{11})(\?.*?)?)$/;
export function YoutubeIdFromLink(link = "https://...") {
    const id1 = link.match(REYoutubeIdEmbed)?.[5];
    const id2 = link.match(REYoutubeIdUrl)?.[5];
    const id3 = link.match(REYoutubeIdShare)?.[4];

    return id1 || id2 || id3 || null;
}
